export const CITY_PATTERN = /^[a-zA-Z0-9 '.-]*$/;
export const CITY_MAX_LENGTH = 85;
